module.exports = __webpack_public_path__ + "img/Fototanten.090afb14.svg";